import touxiang from "@/assets/touxiang_reset.png";
import { deCodeEmoji } from "@/utils/emojiToCode";
import { dateChangeFomat } from "@/utils/date.js";
import { Dialog, Toast } from "vant";
// 处理评论数据
const handleComments = (data) => {
  let likeArr = [];
  data.forEach((item) => {
    //console.log("item--------------", item);
    if (item.isgood == "1" && likeArr.indexOf(item.id) == -1) {
      // console.log("item.id", item.id);
      likeArr.push(item.id);
    }

    item.createtime = dateChangeFomat(item.createtime);

    if (item.content.indexOf("<img") != -1) {
      var imgReg = /<img.*?(?:>|\/>)/gi;
      var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
      var arr = item.content.match(imgReg);
      var srcArr = [];
      for (var i = 0; i < arr.length; i++) {
        var src = arr[i].match(srcReg);
        // 获取图片地址
        srcArr.push(src[1]);
      }
      // console.log('图片地址数组',srcArr)
      item.url = srcArr;
      // 将图片地址从content中删除
      item.content = item.content.replace(/<img.*?(?:>|\/>)/gi, "");
    }
    item.content = item.content.replace(/&amp;nbsp;/g, "\xa0");
    // console.log("item.content", item.content);
    // 如果没头像就用默认头像
    if (!item.avatar) {
      item.avatar = touxiang;
    }
    // 将内容中的表情出来
    item.content = deCodeEmoji(item.content);
  });

  // console.log("处理后的评论数据", data);

  let commentList = data;

  return { commentList, likeArr };
};

// 处理跳转

// 活动跳转
import store from "@/store";
import router from "@/router";
const goActivity = (data) => {
  const { jump_url, slide_name } = data;
  const isUrl = /^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/.test(
    jump_url
  );
  const isGameDetail = jump_url.startsWith("GameDetail://");
  const isTopicId = jump_url.startsWith("topicId://");

  if (!store.state.token && isUrl) {
    store.commit("openLogin");
    return;
  }

  if (isUrl) {
    router.push({
      path: "/homeActivity",
      query: {
        url: jump_url,
        title: slide_name,
      },
    });
  } else if (isGameDetail) {
    const gid = jump_url.slice(13);
    router.push({
      path: "/gamedetails",
      query: {
        gid: gid,
        edition: "0",
      },
    });
  } else if (isTopicId) {
    const topicId = jump_url.slice(10);
    router.push({
      path: "/topic",
      query: {
        topicId: topicId,
        title: slide_name,
      },
    });
  }
};

import { likeComment, hideComment } from "@/api/yzCommunity";
// 点赞处理
const handleLike = async (id, arr, likeArr) => {
  const index = arr.findIndex((item) => item.id == id);
  await likeComment({
    comments_id: id,
    uid: store.state.id,
  }).then((res) => {
    if (res.data.a == "1") {
      if (likeArr.includes(id)) {
        likeArr = likeArr.filter((item) => item !== id);
        arr[index].good--;
      } else {
        arr[index].good++;
        likeArr.push(id);
      }

      return { arr, likeArr };
    }
  });

  return { arr, likeArr };
};
// 删除处理
const handleDelete = async (id) => {
  // console.log("删除帖子", id);

  let result = false;

  await Dialog.confirm({
    title: "确认隐藏该帖子吗？",
    message: "隐藏之后如需展示，请去后台操作！",
  })
    .then(async () => {
      // on confirm
      // console.log("确认删除帖子，请求接口操作", id);
      await hideComment({
        cid: id,
        uid: store.state.id,
      }).then((res) => {
        if (res.data.a == "1") {
          Toast("隐藏帖子成功");
          result = true;
        } else {
          result = false;
        }
      });
    })
    .catch(() => {
      result = false;
      Toast("取消隐藏帖子");
    });

  return result;
};

// 将方法暴露出去
export { handleComments, goActivity, handleLike, handleDelete };
